export const SET_NOTES = "SET_NOTES";
export const ADD_NOTE = "ADD_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const TOGGLE_PIN = "TOGGLE_PIN";
export const DELETE_NOTE = "DELETE_NOTE";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";

export default function notesReducer(state, { type, payload }) {
  switch (type) {
    case SET_NOTES:
      return { ...state, notes: payload };
    case ADD_NOTE: {
      const newNotes = payload.pinned
        ? state.notes.map((note) => (note.pinned ? { ...note, pinned: false } : note))
        : [...state.notes];
      return { ...state, notes: [...newNotes, payload] };
    }
    case UPDATE_NOTE:
      return {
        ...state,
        notes: state.notes.map((note) =>
          note.noteID === payload.noteID ? { ...note, ...payload } : note
        ),
      };
    case TOGGLE_PIN: {
      const targetNote = state.notes.find((n) => n.noteID === payload.noteID);
      const willPin = !targetNote.pinned;
      return {
        ...state,
        notes: state.notes.map((note) => {
          if (note.noteID === payload.noteID) {
            return { ...note, pinned: willPin };
          }
          if (willPin && note.pinned) {
            return { ...note, pinned: false };
          }
          return note;
        }),
      };
    }
    case DELETE_NOTE:
      return {
        ...state,
        notes: state.notes.filter((note) => note.noteID !== payload.noteID),
      };
    case SET_LOADING:
      return { ...state, isLoading: payload };
    case SET_ERROR:
      return { ...state, error: payload };
    default:
      return state;
  }
}
